// extracted by mini-css-extract-plugin
export default {"list":"ListSection_list__24mX7","item":"ListSection_item__bjkD2"};